import { put, takeLatest } from 'redux-saga/effects';

import { cleanBusinessFilters } from '../Business/actions';
import { cleanRejectedFilters } from '../Rejected/actions';
import { cleanVisitsFilters } from '../Visits/actions';
import { cleanAgenciesFilters } from '../Agencies/actions';
import { cleanProcedureFilters } from '../Procedure/actions';
import { cleanReasonFilters } from '../ReasonCode/actions';
import { cleanPayersFilters } from '../Payers/actions';
import { cleanResolutionFilters } from '../ResolutionCode/actions';
import { cleanTaskFilters } from '../TaskCode/actions';
import { cleanRequiredFieldsFilters } from '../RequiredFields/actions';
import { cleanExceptionFilters } from '../ExceptionCodes/actions';

import { CLEAN_FILTERS } from './actionTypes';

function* cleanFilters() {
  yield put(cleanAgenciesFilters());
  yield put(cleanBusinessFilters());
  yield put(cleanRejectedFilters());
  yield put(cleanVisitsFilters());
  yield put(cleanProcedureFilters());
  yield put(cleanReasonFilters());
  yield put(cleanPayersFilters());
  yield put(cleanResolutionFilters());
  yield put(cleanTaskFilters());
  yield put(cleanRequiredFieldsFilters());
  yield put(cleanExceptionFilters());
}

function* cleanFiltersWatcher() {
  yield takeLatest(CLEAN_FILTERS, cleanFilters);
}

export { cleanFiltersWatcher, cleanFilters };
